export const isCooldownActive = (availableAt: string | null) => {
  if (!availableAt) {
    return false;
  }

  const availableAtDate = new Date(availableAt);
  return !Number.isNaN(availableAtDate.getTime()) && availableAtDate.getTime() > Date.now();
};

export const formatAvailableAt = (availableAt: string) => {
  const availableAtDate = new Date(availableAt);

  if (Number.isNaN(availableAtDate.getTime())) {
    return availableAt;
  }

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(availableAtDate);
};
